module.exports = __webpack_public_path__ + "static/media/ilkley-36.99e57ee1.jpg";